(function(){
    'use strict'; 
    angular.module('Login').service('RememberMeService', RememberMeService);
    RememberMeService.$inject = ['$cookies', 'jwtHelper'];

    function RememberMeService($cookies, jwtHelper) {
        const key = 'LX1392929MMMG23131XX03';

        const isRememberLabel = '_is';
        const refreshTokenLabel = '_rr';

        const cookieOptions = {
            expires: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000), // expires in 30 days from now
            path: '/',
            secure: false
        };

        function generateCookieOpt(refreshToken) {
            const token = jwtHelper.decodeToken(refreshToken);
            const expDate = getExpDate(token.exp);
            
            return {
                expires: expDate,
                path: '/',
                secure: false
            }
        }

        function getExpDate(expInSec) {
            const expDate = new Date();
            const expInMins = ((expInSec / 1000) / 60);

            expDate.setMinutes(expDate.getMinutes() + expInMins); 
            return expDate;
        }

        return {
            /**
             * Set the remember me value 
             * 
             * @param {boolean} isRememberMe
             * 
             * @return null
             */
            setRememberMe: (isRememberMe) => {
                $cookies.put(isRememberLabel, angular.toJson(isRememberMe), cookieOptions);
            },
            /**
             * Get the remember me value
             * 
             * @return bool
             */
            getRememberMe: () => {
                const isRememberMe = $cookies.get(isRememberLabel);
                return angular.fromJson(isRememberMe);
            },
            /**
             * Save the remember me related token value
             * 
             * @param {string} refreshToken - refresh token
             * 
             * @return null
             */
            setRememberMeTokens: (refreshToken) => {
                const cookieOpt = generateCookieOpt(refreshToken);
                const encryptedRefreshToken = CryptoJS.AES.encrypt(refreshToken, key);
                $cookies.put(refreshTokenLabel, encryptedRefreshToken.toString(), cookieOpt);
            },
            /**
             * Get the rember me related tokens
             * 
             * @return {string} - refreshToken
             */
            getRememberMeTokens: () => {
                const refreshToken =  $cookies.get(refreshTokenLabel); 
                if (!refreshToken) { return; }
                return CryptoJS.AES.decrypt(refreshToken, key).toString(CryptoJS.enc.Utf8);           
            },
            /**
             * Clear the remember me related cookies
             * 
             * @return null
             */
            removeRememberMeTokens: () => {
                $cookies.remove(isRememberLabel);
                $cookies.remove(refreshTokenLabel);
            }
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./auth/js/services/RememberMeService.js
// module id = 151
// module chunks = 0